/* IMPORT */
import { SYMBOL_OBSERVABLE_WRITABLE } from '../symbols.js';
import { isFunction } from '../utils.js';
/* MAIN */
const isObservableWritable = (value) => {
    return isFunction(value) && (SYMBOL_OBSERVABLE_WRITABLE in value);
};
/* EXPORT */
export default isObservableWritable;
